import { render, staticRenderFns } from "./VinculaCpfEmail.vue?vue&type=template&id=f3b17c0c&scoped=true"
import script from "./VinculaCpfEmail.vue?vue&type=script&lang=js"
export * from "./VinculaCpfEmail.vue?vue&type=script&lang=js"
import style0 from "./VinculaCpfEmail.vue?vue&type=style&index=0&id=f3b17c0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b17c0c",
  null
  
)

export default component.exports